let flag = false;

const setFlag = (f) =>{
    flag=f;
};

const getFlag= () =>{
    return flag;
};

const LandingFlow = {
    setFlag,
    getFlag
};

export default LandingFlow;



// WEBPACK FOOTER //
// ./src/authentication/components/Landing/LandingFlow.js